<div class="change d-flex justify-content-center align-items-center">
    @if(loader){
        <app-loader></app-loader>
    }
    @else {
        <div class="d-flex flex-column align-items-center pb-4">
            <img src="../img/main-logo.png" alt="Logo" width="220" />
            @if(isLinkExpired){
                <div class="change__inner mt-3 mb-5 p-4">
                    <p class="text-center">This link has been expired!</p>
                </div>
            }
            @else {
                <div class="change__inner mt-3 mb-5 p-4">
                    <p class="change__title">Set Your Password</p>
                    <div class="form-field mb-3">
                        <label class="change__label" for="password">New Password</label>
                        <input type="password" id="password" class="form-control" (change)="validatePassword(password)" [(ngModel)]="password" />
                        @if(!isValidPass){
                            <p class="change__passValid mb-0 text-danger">Please enter a strong password.</p>
                        }
                    </div>
                    <div class="form-field mb-3">
                        <label class="change__label" for="re-password">Re-enter New Password</label>
                        <input type="password" id="re-password" class="form-control" (change)="comparePassword()" [(ngModel)]="rePassword" />
                        @if(!passMatched){
                            <p class="change__passValid mb-0 text-danger">Password is not matching.</p>
                        }
                    </div>
                    <div class="form-field mb-3">
                        <small class="change__hint"><b>Strong Password Hint:</b> 6 character long, mix of atleast 1 Uppercase, 1 Lowercase and 1 Special character.</small>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm text-uppercase px-4" [disabled]="!(passMatched && isValidPass && password && rePassword)" (click)="setPassword()">Set Password</button>
                    </div>
                </div>
            }
        </div>
    }
</div>